// FieldsService.js
// Service for managing form field states in the Ottu JS SDK

const { elements } = require('../variables');

class FieldsService {
  constructor(documentCheckout) {
    this.documentCheckout = documentCheckout;
    this.disableFields = false;
  }

  /**
   * Disable or enable form fields and buttons
   * @param {boolean} disable - Whether to disable (true) or enable (false) fields
   * @param {string} type - Optional type for specific field handling (e.g., 'cancel')
   */
  disableEnableFields(disable, type) {
    const radios = this.documentCheckout.querySelectorAll('input');
    for (let index = 0; index < radios.length; index++) {
      const element = radios[index];
      element.disabled = disable;
    }

    const buttons = this.documentCheckout.querySelectorAll('button');
    for (let index = 0; index < buttons.length; index++) {
      const button = buttons[index];
      button.disabled = disable;
    }

    const popupButtons =
      this.documentCheckout.querySelectorAll('.popupButtons');
    if (popupButtons) {
      popupButtons.forEach((button) => {
        disable
          ? button.classList.add('loading')
          : button.classList.remove('loading');
      });
    }

    if (type == 'cancel') {
      const cancelButton =
        this.documentCheckout.querySelectorAll('.cancel-button');
      if (cancelButton) {
        cancelButton.forEach((button) => {
          disable
            ? button.classList.add('loading')
            : button.classList.remove('loading');
        });
      }
    }

    this.disableFields = disable;
    const payButton = this.documentCheckout.querySelector(
      `#${elements.payButton}`
    );
    if (payButton && !type) {
      if (disable) {
        payButton.classList.add('loading');
      } else {
        payButton.classList.remove('loading');
      }
    }
  }

  /**
   * Get current disable state
   * @returns {boolean} - Current disable state
   */
  getDisableState() {
    return this.disableFields;
  }
}

module.exports = FieldsService;
